import React, { useState, useEffect } from 'react'

const CellPhone = props => {
  const [ringing, setRinging] = useState(false);
  const [outgoingCall, setOutgoingCall] = useState(false);
  const [incomingCall, setIncomingCall] = useState(false);

  useEffect(() => { // showing fail-screen does not unmount this component so let's manually remove audio
    props.audioController.removeAudio('ringing_phone');
    props.audioController.removeAudio('callout');
    props.audioController.removeAudio('callin');
}, [props.crossingOver])

  useEffect(() => {
    if (props.data.ringInitially) {
      setRinging(true);
      const ringingTimeout = setTimeout(() => {
        setRinging(false);
      }, 10000)
      return () => {
        props.audioController.removeAudio('ringing_phone');
        props.audioController.removeAudio('callout');
        props.audioController.removeAudio('callin');
        clearTimeout(ringingTimeout)
      }
    } else {
      return () => {
        props.audioController.removeAudio('callin');
        props.audioController.removeAudio('callout');
      }
    }
  }, [])
  useEffect(() => {
    if (ringing) {
      props.audioController.playAudioByName('ringing_phone');
    } else {
      props.audioController.removeAudio('ringing_phone');
    }
  }, [ringing])

  const onClick = () => {
    if (ringing) {
      setRinging(false);
      setIncomingCall(true);
      props.audioController.playAudioByName('callin');
      props.setScore('noPhone');
    } else {
      if (incomingCall) {
        setIncomingCall(false);
        props.audioController.removeAudio('callin');
      } else if (outgoingCall) {
        setOutgoingCall(false);
        props.audioController.removeAudio('callout');
      } else {
        props.setScore('noPhone');
        setOutgoingCall(true);
        props.audioController.playAudioByName('callout');
      }
    }
  };
  return (
    <div className={`CellPhone ${props.view} ${ringing ? 'ringing' : ''}`} onClick={onClick}>

    </div>
  )
}

export default CellPhone